module.exports = __webpack_public_path__ + "img/cuisine_vapeur.6cd57811.png";